import { ModalContext } from "context/modal";
import { useContext } from "react";

export const useModal = () => useContext(ModalContext);
